/* eslint-disable camelcase */
/* eslint-disable ordered-imports/ordered-imports */
import ScrollToTop from "@NA/Components/ScrollToTop";
import bannerCarousel from "@NA/Handlers/ADIGetBannerCarouselHandler";
import loadVisualFilters from "@NA/Handlers/ADIVisualFiltersHandler";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import setPageMetadata from "@insite/client-framework/Common/Utilities/setPageMetadata";
import { trackPageChange } from "@insite/client-framework/Common/Utilities/tracking";
import { CategoryContext } from "@insite/client-framework/Components/CategoryContext";
import { HasShellContext } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import { redirectTo, setStatusCode } from "@insite/client-framework/ServerSideRendering";
import setBreadcrumbs from "@insite/client-framework/Store/Components/Breadcrumbs/Handlers/SetBreadcrumbs";
import {
    getSearchDataModeActive,
    getSelectedCategoryPath,
    getSettingsCollection,
} from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCatalogPageStateByPath } from "@insite/client-framework/Store/Data/CatalogPages/CatalogPagesSelectors";
import {
    getCategoriesDataView,
    getCategoryState,
} from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getProductsDataView } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import clearAllProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/ClearAllProductFilters";
import clearProducts from "@insite/client-framework/Store/Pages/ProductList/Handlers/ClearProducts";
import displayProducts from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import displayBreadcrumb from "@NA/Handlers/ProductList/DisplayBreadcrumb";
import translate from "@insite/client-framework/Translate";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import ProductCompareFlyOut from "@insite/content-library/Components/ProductCompareFlyOut";
import Page from "@insite/mobius/Page";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import addProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";
import qs from "qs";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import { css } from "styled-components";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { CustomSettingCollectionModel } from "@NA/Store/CustomTypeModel/CustomSettingCollectionModel";
import ProductListCoveoSummary from "@NA/Components/Coveo/ProductListCoveoSummary";
import { isCoveoSearchEnabled } from "@NA/Utilities/CoveoUtilities";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { HasCoveoHooks, withCoveoHooks } from "@NA/Components/Coveo/Contexts/CoveoHooksContext";

export interface ProductListPageStyles {
    searchResultWrapper?: InjectableCss;
    searchCount?: TypographyPresentationProps;
}
export const productListPageStyles: ProductListPageStyles = {
    searchResultWrapper: {
        css: css`
            // For ADINA-57705 commented below lines
            // display: flex;
            // flex-direction: row;
            // align-items: center;
            font-weight: 300;
            margin-bottom: 30px;
            margin-top: -15px;
            font-size: 28px;
            color: #002856;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 20px;
                        margin-top: 0;
                    `,
                    css`
                        margin-bottom: 20px;
                        margin-top: 0;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    searchCount: {
        css: css`
            color: #002856;
            font-weight: 600;
            margin-right: 5px;
        `,
    },
};

const styles = productListPageStyles;

const mapStateToProps = (state: CustomApplicationState) => {
    const location = getLocation(state);
    const selectedCategoryPath = getSelectedCategoryPath(state);
    const path =
        selectedCategoryPath || (location.pathname.toLowerCase().startsWith("/content/") ? "" : location.pathname);
    const {
        pages: {
            productList: { isLoading, productFilters, parameter, isSearchPage, filterQuery, productInfosByProductId },
        },
    } = state;
    const catalogPage = getCatalogPageStateByPath(state, path).value;
    const categoriesDataView = getCategoriesDataView(state);
    const productsDataView = getProductsDataView(state, parameter);
    const pagination = getProductListDataViewProperty(state, "pagination");
    const paginationNew = getProductListDataViewProperty(state, "pagination");
    const currentSplitPath = location.pathname.split("/");
    const currentPath = currentSplitPath[currentSplitPath.length - 1];
    const billToId = state.context.session.billToId;
    let acNoSession;
    if (billToId) {
        acNoSession = state.data.billTos.byId[billToId]?.customerNumber;
    }

    return {
        isLoading,
        isCategoryLoading: categoriesDataView.isLoading,
        stockedItemsOnly: productFilters.stockedItemsOnly,
        previouslyPurchasedProducts: productFilters.previouslyPurchasedProducts,
        query: productFilters.query,
        productsDataView,
        firstProductDetailPath: productsDataView.value
            ? productInfosByProductId[productsDataView.value[0]?.id]?.productDetailPath
            : undefined,
        filterQuery,
        isSearchPage,
        search: location.search,
        path,
        breadcrumbLinks: state.components.breadcrumbs.links,
        productListCatalogPage: getCatalogPageStateByPath(state, path).value,
        websiteName: state.context.website.name,
        isAuthenticated: state.context.session.isAuthenticated,
        pages: state.pages,
        location: getLocation(state),
        category: getCategoryState(state, catalogPage?.categoryIdWithBrandId ?? catalogPage?.categoryId).value,
        websiteSettings: getSettingsCollection(state).websiteSettings,
        searchDataModeActive: getSearchDataModeActive(state),
        searchPath: getSettingsCollection(state).searchSettings.searchPath,
        session: state.context.session,
        totalItemCount: paginationNew?.totalItemCount,
        paginationNew,
        pagination,
        isCoveoUser: state.context.session?.userRoles?.includes("Coveo-Access"),
        settingsCollection: getSettingsCollection(state) as unknown as CustomSettingCollectionModel,
        coveoCommerce: state.ADIGlobalData.coveoCommerce,
        currentPage: currentPath,
        bannerCarouselList: state.ADIGlobalData.bannerCarouselStore.bannerCarousel?.bannerCarouselList,
        acNoSession,
        userRoles: state.context.session.userRoles,
        loyaltyUserStateStore: state.ADIGlobalData.loyaltyRewardUserStore,
        userNameSession: state.context.session.userName?.toLocaleLowerCase(),
        breadcrumbs: state.data.catalogPages.byId[path],
        isBreadcrumbsLoading: state.data.catalogPages.isLoading[path],
    };
};

const mapDispatchToProps = {
    clearAllProductFilters,
    displayProducts,
    setBreadcrumbs,
    clearProducts,
    loadVisualFilters,
    addProductFilters,
    displayBreadcrumb,
    bannerCarousel,
};

export const ProductListPageDataContext = React.createContext<{ ref?: React.RefObject<HTMLSpanElement> }>({
    ref: undefined,
});

type Props = HasHistory &
    HasCoveoHooks &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasShellContext &
    PageProps;

interface State {
    isLoading: boolean;
    hasUpdatedUrl: boolean;
    erpQuery: string;
    boostIdsQuery: string;
    utmQuery: string;
    isBannerLoaded: boolean;
}

class ProductListPage extends React.Component<Props, State> {
    // private unsubscribeCoveoQurySummary: Unsubscribe = () => {};
    constructor(props: Readonly<Props>) {
        super(props);
        this.state = {
            isLoading: false,
            hasUpdatedUrl: false,
            erpQuery: "",
            boostIdsQuery: "",
            utmQuery: "",
            isBannerLoaded: false,
        };
        // ADINA-46533
        const { pathname, search } = this.props.location;
        if (search?.includes("searchcriteria") && !search?.includes("erpNumbers")) {
            const queryWithoutQuestionMark = search.startsWith("?") ? search.slice(1) : search;
            const parsedQuery = qs.parse(queryWithoutQuestionMark);
            const erpNumbers = String(parsedQuery.searchcriteria).split("~");
            const erpNumberQuery = `?erpNumbers=${erpNumbers.join("&erpNumbers=")}`;
            const newUrl = `${pathname}${erpNumberQuery}&${queryWithoutQuestionMark}`;
            if (IS_SERVER_SIDE) {
                setStatusCode(302);
                redirectTo(newUrl);
            } else {
                window.location.href = newUrl;
                // this.props.history.replace(newUrl);
            }
        }
        // ADINA-46533
    }

    afterFilters = React.createRef<HTMLSpanElement>();

    enableCoveoSearchToAllTheUsers =
        this.props.settingsCollection.adiCoveoSearchSettingSettings?.enableCoveoSearchToAllTheUsers ?? false;
    enableCoveoSSR = this.props.settingsCollection.adiCoveoSearchSettingSettings?.enableCoveoSSR ?? false;

    isSearchPath() {
        return !!this.props.path.toLowerCase().startsWith(`/${this.props.searchPath.toLowerCase()}`);
    }

    displayBreadcrumbsForCoveo() {
        const { path, breadcrumbs, isBreadcrumbsLoading, displayBreadcrumb } = this.props;
        if (path !== "" && !breadcrumbs && !isBreadcrumbsLoading && !this.isSearchPath()) {
            displayBreadcrumb({ path });
        }
    }

    loadBanner() {
        const { currentPage, bannerCarousel, acNoSession, userRoles, loyaltyUserStateStore, userNameSession, session } =
            this.props;
        const isProRewardsUser = userRoles && userRoles.includes("ADIProRewards");
        const invitedStatus = ["A", "B", "O"];
        const isAuthenticated = session.isAuthenticated;
        const accNoSession = acNoSession?.toString().split("-")[0];
        const accNoLTY = loyaltyUserStateStore.user.userId != undefined ? loyaltyUserStateStore.user.userId : "";
        const emailLTY =
            loyaltyUserStateStore.user.email != undefined ? loyaltyUserStateStore.user.email?.toLocaleLowerCase() : "";
        const isRewardInvitedUser =
            invitedStatus.indexOf(loyaltyUserStateStore.user.status) > -1 &&
            !isProRewardsUser &&
            accNoLTY === accNoSession &&
            loyaltyUserStateStore.user.isEnrolled === false &&
            userNameSession === emailLTY;
        const isRewardEnrolledUser =
            invitedStatus.indexOf(loyaltyUserStateStore.user.status) > -1 &&
            accNoLTY === accNoSession &&
            loyaltyUserStateStore.user.isEnrolled &&
            (isProRewardsUser || false);

        bannerCarousel({
            isPreview: false,
            pageUrl: currentPage,
            ...(isAuthenticated && { isRewardEnrolledUser, isRewardInvitedUser }),
        });
        this.setState(prevState => ({ ...prevState, isBannerLoaded: true }));
    }

    loadProducts() {
        const { path, search } = this.props;
        this.props.displayProducts({
            path,
            queryString: search,
            isSearch: this.isSearchPath(),
        });
    }

    UNSAFE_componentWillMount(): void {
        const {
            productsDataView,
            location: { search },
        } = this.props;

        if (this.enableCoveoSearchToAllTheUsers) {
            this.displayBreadcrumbsForCoveo();
        }

        if (!this.enableCoveoSearchToAllTheUsers) {
            if (productsDataView.value && !IS_SERVER_SIDE) {
                this.loadProducts();
            }
            const checkWindowObj = () => {
                if (typeof window !== "undefined") {
                    return window.location.href.includes("attributes");
                }
                return false;
            };
            if (!productsDataView.value && !productsDataView.isLoading) {
                this.loadProducts();
            } else if (!IS_SERVER_SIDE && productsDataView.value) {
                const { searchTermRedirectUrl } = productsDataView;

                let updatedSearchTermRedirectUrl = searchTermRedirectUrl;

                if (searchTermRedirectUrl?.toLowerCase().includes("#criteria")) {
                    updatedSearchTermRedirectUrl = searchTermRedirectUrl.split("#criteria")[0];
                }

                const startsWithProtocol = updatedSearchTermRedirectUrl?.lastIndexOf("http", 0) === 0;

                // Check that the request is not a redirection to where we are currently
                if (updatedSearchTermRedirectUrl) {
                    if (
                        search?.includes("searchcriteria") &&
                        search?.includes("erpNumbers") &&
                        this.state.erpQuery !== updatedSearchTermRedirectUrl
                    ) {
                        this.setState({ erpQuery: updatedSearchTermRedirectUrl });
                    }

                    const startsWithProtocol = updatedSearchTermRedirectUrl.lastIndexOf("http", 0) === 0;
                    const locationPath = startsWithProtocol
                        ? window?.location?.toString()
                        : window?.location?.pathname + window?.location?.search;
                    if (
                        locationPath !== updatedSearchTermRedirectUrl &&
                        window?.localStorage?.getItem("searchTermRedirectUrl") !== updatedSearchTermRedirectUrl
                    ) {
                        if (startsWithProtocol) {
                            window.location.replace(updatedSearchTermRedirectUrl);
                        } else {
                            this.props.history.replace(updatedSearchTermRedirectUrl);
                        }
                        return;
                    }
                    if (locationPath === updatedSearchTermRedirectUrl) {
                        window?.localStorage?.setItem("searchTermRedirectUrl", updatedSearchTermRedirectUrl);
                    }
                }
            } else if (this.props.isSearchPage) {
                this.redirectToProductDetailIfExactMatch();
            }
        }

        if (this.props.productListCatalogPage) {
            this.setMetadata();
            if (
                this.props.breadcrumbLinks?.map(o => o.href).join(",") !==
                this.props.productListCatalogPage.breadCrumbs?.map(o => o.url).join(",")
            ) {
                this.setProductListBreadcrumbs();
            }
        } else if (this.props.isSearchPage) {
            this.setMetadataTitle(translate("Search Results"));
            if (!this.props.breadcrumbLinks) {
                this.setSearchBreadcrumbs();
            }
        }
    }

    componentWillUnmount(): void {
        if (!this.enableCoveoSearchToAllTheUsers) this.props.clearProducts();
    }

    componentDidMount() {
        if (!this.state.isBannerLoaded && !this.props.isAuthenticated) {
            this.loadBanner();
        }
    }

    // remove duplicates
    formatUrl(url: string) {
        const params = url
            .replace(/.*\?/g, "") // replace everything before '?'
            .split("&") // split by '&'
            // .filter((e, i, a) => a.indexOf(e) === i) // filter duplicates
            .join("&"); // join by '&'

        const result = url.replace(/\?.*/g, `?${params}`); // replace link params with params without duplicates
        return result;
    }

    componentDidUpdate(prevProps: Props, prevState: State): void {
        const {
            isLoading,
            filterQuery,
            location: { pathname, search },
            path,
            productListCatalogPage,
            searchDataModeActive,
            isAuthenticated,
            loyaltyUserStateStore,
        } = this.props;

        if (productListCatalogPage) {
            this.setMetadata();
            trackPageChange();
            if (
                productListCatalogPage.categoryId !== prevProps.productListCatalogPage?.categoryId ||
                !this.props.breadcrumbLinks
            ) {
                this.setProductListBreadcrumbs();
            }
        } else if (this.props.isSearchPage) {
            // For pages that do not have a productListCatalogPage, mainly the Search Page
            this.setMetadataTitle(translate("Search Results"));
            trackPageChange();
            if (this.props.query !== prevProps.query || !this.props.breadcrumbLinks) {
                this.setSearchBreadcrumbs();
            }
        }
        if (this.props.query !== prevProps.query) {
            window?.localStorage?.removeItem("searchTermRedirectUrl");
        }

        if (path !== prevProps.path) {
            this.setState(prevState => ({ ...prevState, isBannerLoaded: false }));
        }
        if (!this.state.isBannerLoaded && (!isAuthenticated || !loyaltyUserStateStore.isLoading)) {
            this.loadBanner();
        }

        if (this.enableCoveoSearchToAllTheUsers) {
            if (path !== prevProps.path) {
                this.displayBreadcrumbsForCoveo();
            }

            // Do not run any elastic plp or search page logic if the coveo search is enabled for all the users
            return;
        }

        // handle the query string change requests initiated by the filtering widget setQueryFilter calls
        // Make sure we are fully loaded, since a loading product list will change the filteQuery to match the current pathname/search
        // This can trigger a loop with the pathname/search updating and the filterQuery not updated till the productList is loaded
        // && !this.state.hasUpdatedUrl Condition is removed as per ticket ADINA-48866
        if (!isLoading && filterQuery !== prevProps.filterQuery) {
            const currentUrl = `${pathname}${search}`;
            let newUrl = filterQuery ? `${pathname}?${filterQuery}` : pathname;
            const filterQueryLabel = filterQuery?.split("=")[0];

            if (prevProps.filterQuery === "" && filterQuery === "" && pathname?.toLowerCase() === "/search") {
                return;
            }

            if (
                this.state.erpQuery !== "" &&
                `/search${search}`.includes(this.state.erpQuery.split("&attributes")[0]) &&
                search !== this.state.erpQuery
            ) {
                newUrl = filterQuery
                    ? `${this.state.erpQuery.split("&attributes")[0]}&${filterQuery}`
                    : this.state.erpQuery;
            }

            const currentUrlSearchParams = currentUrl.split("?")[1];
            const currUrl = new URLSearchParams(currentUrlSearchParams);
            const boostIdsValue = decodeURIComponent(currUrl.get("boostids") || "");

            if (
                boostIdsValue !== "" &&
                currentUrl?.toLowerCase().includes(boostIdsValue?.toLowerCase()) &&
                search !== boostIdsValue &&
                !filterQuery?.toLowerCase().includes("attributes") &&
                filterQueryLabel &&
                !filterQuery?.toLowerCase().includes(filterQueryLabel.toLowerCase())
            ) {
                newUrl = filterQuery ? `${this.state.boostIdsQuery}&${filterQuery}` : this.state.boostIdsQuery;
            } else if (
                boostIdsValue !== "" &&
                currentUrl?.toLowerCase().includes(boostIdsValue?.toLowerCase()) &&
                search !== boostIdsValue &&
                filterQuery?.toLowerCase().includes("attributes")
            ) {
                this.setState({ boostIdsQuery: "" });
            }

            if (
                this.state.utmQuery !== "" &&
                currentUrl?.toLowerCase().includes(this.state.utmQuery?.toLowerCase()) &&
                search !== this.state.utmQuery &&
                filterQueryLabel &&
                !filterQuery?.toLowerCase().includes(filterQueryLabel.toLowerCase())
            ) {
                newUrl = filterQuery ? `${this.state.utmQuery}&${filterQuery}` : this.state.utmQuery;
            }

            if (newUrl === "/search" && this.state.erpQuery === "") {
                newUrl += search;
                newUrl = this.formatUrl(newUrl);
                this.setState({ erpQuery: newUrl });
            }

            if (currentUrl?.toLowerCase().includes("boostids") && boostIdsValue === "") {
                newUrl += search;
                newUrl = this.formatUrl(newUrl);
                this.setState({ boostIdsQuery: newUrl });
            }

            if (
                currentUrl?.toLowerCase().includes("utm") ||
                currentUrl?.toLowerCase().includes("gclid") ||
                (currentUrl?.toLowerCase().includes("gad") && this.state.utmQuery === "")
            ) {
                newUrl += search;
                newUrl = this.formatUrl(newUrl);
                this.setState({ utmQuery: newUrl });
            }

            // set the url params
            const getUpdatedNewUrl = (newUrl: string) => {
                if (newUrl.startsWith("/search")) {
                    return newUrl;
                }

                const searchParams = newUrl.split("?")[1];
                const url = new URLSearchParams(searchParams);

                const currentUrlSearchParams = currentUrl.split("?")[1];
                const currUrl = new URLSearchParams(currentUrlSearchParams);
                const filterQueryLabel = filterQuery?.split("=")[0];

                const filterParams = new URLSearchParams(filterQuery);

                const pageQuery = filterParams.get("page") || null;
                const pageSize = filterParams.get("pageSize") || null;
                const sort = filterParams.get("sort") || null;
                const attributes = filterParams.get("attributes") || null;

                pageQuery && url.set("page", decodeURIComponent(pageQuery));
                pageSize && url.set("pageSize", decodeURIComponent(pageSize));
                sort && url.set("sort", decodeURIComponent(sort));
                if (!this.props.isSearchPage && (sort === null || sort === "1")) {
                    url.set("sort", "Bestseller");
                }

                // set attributes
                if (attributes && filterQuery) {
                    url.set("attributes", decodeURIComponent(attributes));
                } else if (!filterQuery || !filterQueryLabel) {
                    url.delete("attributes");
                }

                // get boostid
                const boostIdsValue = decodeURIComponent(currUrl.get("boostids") || "");

                // set saved boostid

                const queryString = window.location.search;
                const params = new URLSearchParams(queryString);
                const existingUrlWithAttributes = params.get("attributes");
                const attrExistInUrlAfterFilterApplied = filterQuery?.includes("attributes");

                if (boostIdsValue && url && (pageQuery || pageSize || sort)) {
                    url.set("boostids", boostIdsValue);
                }
                if (boostIdsValue && existingUrlWithAttributes && attrExistInUrlAfterFilterApplied) {
                    url.set("boostids", boostIdsValue);
                } else if (boostIdsValue && existingUrlWithAttributes && !attrExistInUrlAfterFilterApplied) {
                    url.delete("boostids");
                } else if (boostIdsValue && !existingUrlWithAttributes && attrExistInUrlAfterFilterApplied) {
                    url.delete("boostids");
                }

                // set utm params
                for (const value of currUrl.keys()) {
                    // set only utm params
                    if (value.startsWith("utm") || (boostIdsValue && !pageQuery)) {
                        if (currUrl.get(value)) {
                            url.set(value, currUrl.get(value)!);
                        }
                    }
                }

                const updatedUrl = url.toString() !== "" ? `${pathname}?${url}` : pathname;

                return updatedUrl;
            };

            newUrl = getUpdatedNewUrl(newUrl);

            if (newUrl !== currentUrl) {
                newUrl = this.formatUrl(newUrl);
                this.setState({ hasUpdatedUrl: false });
                this.props.history.push(newUrl);
                return;
            }

            this.setState({ hasUpdatedUrl: true });
        }

        if (!isLoading && this.props.productsDataView.value && pathname === prevProps.location.pathname) {
            // Check that the request is not a redirection to where we are currently
            const { searchTermRedirectUrl } = this.props.productsDataView;

            let updatedSearchTermRedirectUrl = searchTermRedirectUrl;

            if (searchTermRedirectUrl?.toLowerCase().includes("#criteria")) {
                updatedSearchTermRedirectUrl = searchTermRedirectUrl.split("#criteria")[0];
            }

            if (updatedSearchTermRedirectUrl) {
                if (
                    search?.includes("searchcriteria") &&
                    search?.includes("erpNumbers") &&
                    this.state.erpQuery !== updatedSearchTermRedirectUrl
                ) {
                    this.setState({ erpQuery: updatedSearchTermRedirectUrl });
                }

                const startsWithProtocol = updatedSearchTermRedirectUrl.lastIndexOf("http", 0) === 0;
                const locationPath = startsWithProtocol
                    ? window?.location?.toString()
                    : window?.location?.pathname + window?.location?.search;
                if (
                    locationPath !== updatedSearchTermRedirectUrl &&
                    window?.localStorage?.getItem("searchTermRedirectUrl") !== updatedSearchTermRedirectUrl
                ) {
                    if (startsWithProtocol) {
                        window.location.replace(updatedSearchTermRedirectUrl);
                    } else {
                        this.props.history.replace(updatedSearchTermRedirectUrl);
                    }
                    return;
                }
                if (locationPath === updatedSearchTermRedirectUrl) {
                    window?.localStorage?.setItem("searchTermRedirectUrl", updatedSearchTermRedirectUrl);
                }
            }

            this.redirectToProductDetailIfExactMatch();
        }

        if (!isLoading && (search !== prevProps.search || this.props.path !== prevProps.path)) {
            if (this.props.path !== prevProps.path) {
                this.props.clearAllProductFilters({
                    removeAll: true,
                });
            }
            this.loadProducts();
        }

        if (searchDataModeActive !== prevProps.searchDataModeActive) {
            // refresh the search results when search data mode has been toggled in the cms shell
            this.loadProducts();
        }

        if (
            !prevProps.productsDataView.value &&
            this.props.productsDataView.value &&
            this.props.productsDataView.pagination &&
            this.props.productsDataView.value.length === 0 &&
            this.props.productsDataView.pagination.totalItemCount > 0
        ) {
            this.props.addProductFilters({ page: 1 });
        }
    }

    redirectToProductDetailIfExactMatch() {
        if (!this.props.productsDataView.value || this.enableCoveoSearchToAllTheUsers) {
            return;
        }

        const {
            location: { search },
            firstProductDetailPath,
        } = this.props;

        const { exactMatch, value: products } = this.props.productsDataView;
        if (exactMatch && !this.props.stockedItemsOnly && products.length) {
            let productDetailUrl = firstProductDetailPath ?? products[0].canonicalUrl;
            const parsedQuery = parseQueryString<{ query: string }>(search);
            const query = parsedQuery.query;
            if (!query) {
                return;
            }
            if (productDetailUrl.indexOf("?") !== -1) {
                productDetailUrl += `&criteria=${encodeURIComponent(query)}`;
            } else {
                productDetailUrl += `?criteria=${encodeURIComponent(query)}`;
            }

            if (IS_SERVER_SIDE) {
                setStatusCode(302);
                redirectTo(productDetailUrl);
            } else {
                this.props.history.replace(productDetailUrl);
            }
        }
    }

    setMetadata() {
        const { productListCatalogPage, websiteName, location, websiteSettings } = this.props;
        if (!productListCatalogPage) {
            return;
        }

        const {
            metaDescription,
            metaKeywords,
            openGraphImage,
            openGraphTitle,
            openGraphUrl,
            title,
            primaryImagePath,
            canonicalPath,
            alternateLanguageUrls,
        } = productListCatalogPage;

        setPageMetadata(
            {
                metaDescription,
                metaKeywords,
                openGraphImage: openGraphImage || primaryImagePath,
                openGraphTitle,
                openGraphUrl,
                title,
                currentPath: location.pathname,
                canonicalPath,
                alternateLanguageUrls: alternateLanguageUrls ?? undefined,
                websiteName,
            },
            websiteSettings,
        );
    }

    setMetadataTitle(title: string) {
        const { websiteName, location, websiteSettings } = this.props;

        setPageMetadata(
            {
                title,
                currentPath: location.pathname,
                websiteName,
            },
            websiteSettings,
        );
    }

    setProductListBreadcrumbs() {
        const breadcrumbs = this.props.productListCatalogPage!.breadCrumbs!;

        const updatedBreadcrumbs = breadcrumbs
            .filter(breadcrumb => breadcrumb.text !== "Shop All Products")
            .map(breadcrumb => {
                if (breadcrumb.text === "Brands") {
                    return { children: breadcrumb.text, href: "/Catalog/shop-brands" };
                }

                return { children: breadcrumb.text, href: breadcrumb.url };
            });

        this.props.setBreadcrumbs({ links: updatedBreadcrumbs });
    }

    setSearchBreadcrumbs() {
        if (this.props.query) {
            this.props.setBreadcrumbs({
                links: [
                    { children: translate("Home"), href: "/" },
                    { children: `${translate("Search Results for")} "${this.props.query}"` },
                ],
            });
        }
    }
    render() {
        if (
            this.props.productsDataView.value?.length &&
            this.props.productsDataView.exactMatch &&
            !this.props.stockedItemsOnly
        ) {
            // prevent a flash of data when PLP immediately redirects to PDP
            return null;
        }

        return (
            <Page>
                <CategoryContext.Provider value={this.props.category}>
                    <ProductListPageDataContext.Provider value={{ ref: this.afterFilters }}>
                        {isCoveoSearchEnabled(this.props.settingsCollection, this.props.isCoveoUser) ? (
                            <ProductListCoveoSummary></ProductListCoveoSummary>
                        ) : (
                            this.props.isSearchPage &&
                            this.props.query && (
                                <StyledWrapper {...styles.searchResultWrapper}>
                                    <Typography {...styles.searchCount} as="span">
                                        {this.props.totalItemCount ? this.props.totalItemCount.toLocaleString() : ""}
                                    </Typography>
                                    Results for "{this.props.query}"
                                </StyledWrapper>
                            )
                        )}
                        <Zone contentId={this.props.id} zoneName="Content" />
                        <Modals />
                        {this.props.isAuthenticated && <ProductCompareFlyOut />}
                        <ScrollToTop />
                    </ProductListPageDataContext.Provider>
                </CategoryContext.Provider>
            </Page>
        );
    }
}

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withCoveoHooks(withHistory(ProductListPage))),
    definition: {
        hasEditableUrlSegment: false,
        hasEditableTitle: false,
        supportsCategorySelection: true,
        pageType: "System",
    },
};

export default pageModule;

export const ProductListPageContext = "ProductListPage";
